module.exports = __webpack_public_path__ + "static/media/photo296.2f2c4a4c.jpg";